module.exports = __webpack_public_path__ + "static/media/neg-feedback.2eeaaed0.png";